import React, { useEffect, useState } from 'react';
import { useQuoteApi } from '../../../app/api/quote';
import { IError } from '../../../app/interfaces/response/IResponse';
import { useTranslation } from 'react-i18next';
import { BLErrorCode } from '../../../app/enums/BLErrorCode';

type CRMFastRateFrameProps = {
    model: string | null;
    errors: Array<IError>;
}

const CRMFastRateFrame: React.FC<CRMFastRateFrameProps> = ({ model, errors }) => {

    const { t } = useTranslation();

    let errorMessage: string | null = null;

    if (errors && errors.length > 0) {
        // Ищем конкретные ошибки
        const innerError = errors.find(err => err.errorCode === BLErrorCode.InnerError);
        const crmUserError = errors.find(err => err.errorCode === BLErrorCode.CRMUserNotFound);

        if (innerError) {
            errorMessage = t("shared.errors.server-error");
        } else if (crmUserError) {
            errorMessage = t("shared.errors.crm-user-not-found-error");
        } else {
            errorMessage =  t("shared.errors.server-error");
        }
    }

    if (model === null || errorMessage !== null) {
        return <div style={{ color: 'red', padding: '20px', textAlign: 'center' }}>{errorMessage}</div>;
    }
    
    return (
        <iframe
            referrerPolicy="no-referrer"
            allow="local-network-access"
            src={model}
            title="CRM"
            width="100%"
            height="100%"
            style={{ border: 'none' }}
        />
    );
};

export default CRMFastRateFrame;

